// Finer Finds theme — JS added in Phase 2

/* ============================================================
   Phase 11 — GA4 event helper (SFE-01..03)
   Mirrors reference/landing/ff-analytics.js:127-129. Two differences,
   both forced by this page:
     - send_to is mandatory (D-02): shop pages load a second GA4 stream,
       G-T552PV95CW, that we do not own.
     - ffTrackThen defers a caller-supplied navigation until gtag confirms
       the hit via event_callback, with a 300ms fallback so navigation can
       never be stranded. No delivery-guarantee transport flag is used: no
       key outside CHECKLIST section 6 goes on these events.
   Guarded per D-03: a tracking failure must never break search/filter/sort.
   ============================================================ */
(function (w) {
  var FF_GA4_ID = 'G-68VPTLLHDW';

  w.ffTrack = function (name, params) {
    try {
      if (typeof w.gtag !== 'function') { return; }
      var p = {};
      if (params) { for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) { p[k] = params[k]; } } }
      p.send_to = FF_GA4_ID;
      w.gtag('event', name, p);
    } catch (e) { /* analytics must never break the page */ }
  };

  w.ffTrackThen = function (name, params, done) {
    var fired = false;
    function finish() {
      if (fired) { return; }
      fired = true;
      try { if (typeof done === 'function') { done(); } } catch (e) {}
    }
    try {
      if (typeof w.gtag !== 'function') { finish(); return; }
      var p = {};
      if (params) { for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) { p[k] = params[k]; } } }
      p.send_to = FF_GA4_ID;
      p.event_callback = finish;
      w.gtag('event', name, p);
      w.setTimeout(finish, 300);
    } catch (e) { finish(); }
  };
})(window);

/* ============================================================
   Contact taps (shop) -- mirrors reference/landing/ff-analytics.js
   contact_click: tel: / mailto: / instagram.com links, including the
   product page "Email us about this piece" and "Enquire about similar
   pieces" buttons. Same event + contact_channel param as the landing,
   so the weekly report counts shop enquiries. GA4 pagePath tells which
   product. Capture phase, never calls preventDefault.
   ============================================================ */
document.addEventListener('click', function (e) {
  try {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) { return; }
    var href = a.getAttribute('href') || '';
    var channel = /^tel:/i.test(href) ? 'phone'
      : /^mailto:/i.test(href) ? 'email'
      : /(^|\.)instagram\.com$/i.test(a.hostname || '') ? 'instagram' : '';
    if (channel && typeof window.ffTrack === 'function') {
      window.ffTrack('contact_click', { contact_channel: channel });
    }
  } catch (err) { /* analytics must never break the page */ }
}, true);

/* ============================================================
   Phase 5 — Scroll-reveal observer
   Ports reference/landing/app.jsx lines 586-593.
   Adds class "is-visible" to every .ff-reveal element when it
   enters the viewport. Idempotent (window.__ffRevealInit guard).
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  if (window.__ffRevealInit) return;
  window.__ffRevealInit = true;

  var targets = document.querySelectorAll('.ff-reveal, .reveal-on-scroll, .reveal-stagger');
  if (!targets.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    // Fallback: show everything immediately (Safari < 12.1, older Android)
    targets.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    // threshold 0 (not a %) so tall elements — e.g. a long product grid that is
    // taller than the viewport — reveal as soon as ANY part enters. A percentage
    // threshold is unreachable for elements taller than the viewport (the grid
    // never shows on mobile, "blank then loads" on desktop).
    { threshold: 0, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) { observer.observe(el); });
});

/* ============================================================
   Phase 5 — Carousel init helper
   Usage: window.ffInitCarousel('section-id')
   Wires [data-carousel-prev="ID"] and [data-carousel-next="ID"]
   buttons to the scroll-snap track inside that section.
   Scoped by id so multiple carousel instances do not collide.
   ============================================================ */
window.ffInitCarousel = function (id) {
  var section = document.getElementById(id);
  if (!section) return;

  var track = section.querySelector('.ff-carousel-track');
  if (!track) return;

  var slideWidth = function () {
    var slide = track.querySelector('.ff-collection-slide');
    return slide ? slide.offsetWidth : 320;
  };

  var prevBtn = document.querySelector('[data-carousel-prev="' + id + '"]');
  var nextBtn = document.querySelector('[data-carousel-next="' + id + '"]');

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  }
};

/* ============================================================
   Cart — AJAX line updates via the Section Rendering API.
   Quantity is fixed (one-of-a-kind pieces): no steppers, only
   remove + a per-line "Free appraisal" line-item property.
   Delegated listeners on document survive section re-renders.
   Per-key promise chain serializes concurrent changes.
   Idempotent (window.__ffCartInit guard). Exposes
   window.ffCartUpdate(key, qty) and window.ffCartSetAppraisal(key, on).
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  if (window.__ffCartInit) return;
  window.__ffCartInit = true;

  var queues = {};

  function sectionId() {
    var el = document.getElementById('ff-cart');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
      if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
      b.setAttribute('aria-label', n + ' items');
    });
  }

  function showError(show) {
    var e = document.querySelector('[data-cart-error]');
    if (!e) return;
    if (show) { e.removeAttribute('hidden'); } else { e.setAttribute('hidden', ''); }
  }

  function setItemLoading(key, on) {
    var item = document.querySelector('.ff-cart-item[data-key="' + String(key).replace(/"/g, '\\"') + '"]');
    if (item) item.classList.toggle('is-loading', on);
  }

  function postChange(key, payload) {
    var sid = sectionId();
    payload.sections = sid;
    payload.sections_url = '/cart';
    var prev = queues[key] || Promise.resolve();
    var next = prev.then(function () {
      showError(false);
      setItemLoading(key, true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart change failed: ' + r.status);
        return r.json();
      }).then(function (state) {
        if (typeof state.item_count === 'number') setCount(state.item_count);
        if (state.sections && sid && state.sections[sid]) {
          var tmp = document.createElement('div');
          tmp.innerHTML = state.sections[sid];
          var fresh = tmp.querySelector('#ff-cart');
          var current = document.getElementById('ff-cart');
          if (fresh && current) current.replaceWith(fresh);
        }
        return state;
      }).catch(function (err) {
        setItemLoading(key, false);
        showError(true);
        throw err;
      });
    });
    queues[key] = next.catch(function () {});
    return next;
  }

  window.ffCartUpdate = function (key, quantity) {
    return postChange(key, { id: key, quantity: quantity });
  };

  window.ffCartSetAppraisal = function (key, on) {
    return postChange(key, { id: key, quantity: 1, properties: on ? { 'Free appraisal': 'Requested' } : {} });
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.ff-cart')) return;
    var remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      window.ffCartUpdate(remove.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-appraisal]')) {
      window.ffCartSetAppraisal(t.getAttribute('data-key'), t.checked);
    }
  });
});
